import React from 'react';
import './index.css';

const Home = () => (
  <section id='ever-10-body-content'>
    <div className='container-fluid'>
      <div className='row pl-lg-3 pr-lg-3 mt-3'>
        <div className='col-lg-6 ever-10-howjsay-wrapper pl-lg-0 pr-lg-2'>
          <div className='ever-10-howjsay-inner-wrapper baywatch-card'>
            <h3>Parking</h3>
            <h2>Bay Watch</h2>
            <p>Parking. Sorted.</p>
            <img
              className='img-fluid pt-2'
              src={require('../../../static/img/home/baywatch.png')}
              alt='Bay Watch app parking map'
            />
          </div>
        </div>

        <div className='col-lg-6 ever-10-howjsay-wrapper pl-lg-2 pr-lg-0'>
          <div className='ever-10-howjsay-inner-wrapper howjsay-card'>
            <h3>Pronunciation</h3>
            <h2>Howjsay</h2>
            <p>Professional English pronunciation, individually recorded.</p>
            <img
              className='img-fluid howjsay-screenshot'
              src={require('../../../static/img/home/howjsay-home.png')}
              alt='Howjsay pronunciation app'
            />
          </div>
        </div>
      </div>
    </div>

    <div className='ml-lg-3 mr-lg-3 mt-3 mb-3'>
      <div className='ever-10-howjsay-inner-wrapper weather-report-card pl-lg-3 pr-lg-3'>
        <div className='container'>
          <div className='row justify-content-center align-items-center'>
            <div className='col-lg-4'>
              <div className='ever-10-howjsay-inner-wrapper get weather-report-copy'>
                <h3>Weather</h3>
                <h2>Weather Report</h2>
                <p>Forecasts with context, comparison and insight.</p>
              </div>
            </div>
            <div className='col-lg-8'>
              <img
                className='img-fluid weather-report-screenshot'
                src={require('../../../static/img/home/weather-report-home.png')}
                alt='Weather Report app showing the London forecast'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Home;
